import { render, staticRenderFns } from "./CustomerAssetCategoriesManagerWidget.vue?vue&type=template&id=e61955e0"
import script from "./CustomerAssetCategoriesManagerWidget.vue?vue&type=script&lang=js"
export * from "./CustomerAssetCategoriesManagerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports